/** * 业务代码：M0002 * 业务名称：账户资料-视频见证 */

<template>
  <div :class='{"common-qrcode": true, "imgStyle":isImgStyle, "qrcode-disabled": isDisabled}'>
    <div class="qecode-box" >
      <div class="imgStyleText" v-if="imgStyleText">
        {{imgStyleText}}
      </div>
      <div class="qr-code">
        <!-- 二维码 -->
        <img  :src="twoCode" alt="" class="phoneScan">
        <div class="qr-txt">
          <div>打开手机微信</div>
          <div>扫一扫</div>
        </div>
        <div class="qr-btn" @click="getCode()">
          <span>手机扫码上传</span>
        </div>
      </div>
      <!-- <div v-if='isShowRight' class='right'>
        <img :src="rightImg" alt="" class="rigImg">
      </div> -->
   
    </div>
     <!-- 二维码弹窗 -->
     <k-dialog
        v-if="dialogVisible"
        class="common-qrcode-dialog"
        ref = "commonQrcodoDialog"
        :options = "{title: '请手机扫码上传', center:true, width: '28%',height:300,top:'0',destroyOnClose:true,
        isCanClickClose: false,showClose: false,
        onCloseBefore: finishScan,
        buttons:[{text:'关闭', handler: finishScan}]}">
        <div>
          <div class="dia-img" @click="updateCode()">
            <img :src="qrCode" alt="">
          </div>
          <div class="dia-txt">
            <div>请打开手机</div>
            <div>扫码左侧二维码上传文件</div>
          </div>
        </div>
      </k-dialog>
  </div>
</template>

<script>
import { getQrCode } from "@/service/image-service";
import kDialog from "../../common/dialog.vue";

export default {
  data () {
    return {
      qrCode: "",
      dialogVisible: false,
      twoCode: require("@img/newCode/qrCode/icon-phone-scan.svg"),
      rightImg:require("@img/newCode/qrCode/shaoma.png")
    };
  },
  props: ["qrCodeType","isImgStyle","imgStyleText","isDisabled"],
  mounted () {
  },
  computed: {
    //流水号
    apptSn: function () {
      return this.$store.state.apptSn;
    },
    busiCode: function () {
      return this.$store.state.busicode;
    },
    userType: function () {
      return this.$store.state.usertype;
    },
  },
  components: {
    kDialog
  },
  methods: {
    //获取二维码
    async getCode () {
      // let userInfo = this.$storage.getJsonSession(this.$definecfg.USER_INFO)|| {};
      const res = await getQrCode(this.apptSn, this.busiCode, this.userType, this.qrCodeType);
      this.qrCode = "data:image/png;base64," + res.Data[0].imgBase64;
      //弹框显示
      this.dialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.commonQrcodoDialog.open();
      });
    },
    updateCode (){
      this.getCode();
    },
    //已扫码上传
    finishScan () {
      // this.$refs.commonQrcodoDialog.close();
      this.dialogVisible=false;
      //调用接口 退出手机登录
      // this.$syscfg.K_Request("F0000080",{});
      this.$emit("finishScan");
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/styles/less/variable.less";

//默认ocr识别上传二维码样式
.common-qrcode {
  background: #fff;
  width: 100%;
  .qecode-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .qr-code{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 346px;
    height: 246px;
    border: 1px solid #D0D0D0;
    border-radius: 4px;
    img{
      margin-bottom: 10px;
    }
    .phoneScan{
      width: 64px;
      height: 64px;
    }
    .qr-txt{
      font-size: 16px;
      color: rgba(105,105,105,0.85);
      text-align: center;
      line-height: 18px;
      font-weight: 400;
      margin-bottom: 30px;
      div{
        margin-bottom: 3px;
      }
    }
    .qr-btn{
      background: #E5C48A;
      border-radius: 2px;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      line-height: 1;
      // font-weight: 600;
      width: 180px;
      height: 40px;
      display: block;
      cursor: pointer;
      span{
        display: block;
        margin: 12px 0;
      }
    }
  }
  .common-qrcode-dialog{
    /deep/.el-dialog__body{
      position: relative;
      width: 100%;
      padding: 0;
      margin-bottom: 28px;
      .dia-img{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 168px;
        height: 168px;
        border: 1px solid rgba(0,0,0,0.15);
        border-radius: 4px;
        margin-left: 92px;
        margin-top: 56px;
        img{
          width: 100%;
          height: 100%;    
      }
      }
      
      .dia-txt{
        display: inline-block;
        position: absolute;
        top: 124px;
        left: 291px;
        div{
          margin-bottom: 5px;
        }
      }
    }
    // /deep/.el-dialog__footer{
    //   position: relative;
    //   width: 100%;
    //   height: 56px;
    //   span{
    //     display: inline-block;
    //     width: 120px;
    //     height: 32px;
    //     line-height: 32px;
    //     text-align: center;
    //     position: absolute;
    //     top: 0;
    //     right: 20px;
    //     background: #E5C48A;
    //     border-radius: 2px;
    //     font-family: PingFangSC-Regular;
    //     font-size: 14px;
    //     color: #FFFFFF;
    //     font-weight: 400;
    //   }
    // }
  }
}
//图片上传二维码样式
.imgStyle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 30px 10px 4%;
    .imgStyleText{
      height: 30px;
      line-height: 24px;
      font-size: 20px;
      font-weight: 400;
      .fontsize-title-medium();
    }
    .qr-code{
      border: none !important;
      margin-left: 50px;
      flex-wrap: wrap;
      height: 100px;
      justify-content: center;
      width: 513px;
      padding: 0 60px;
      flex-direction: row;
      display: flex;
      .phoneScan{
        margin-bottom: 0;
      }
      .qr-txt{
        width: 96px;
        height: 36px;
        margin: 0 30px 0 16px;
      }
    }
}

.qrcode-disabled{
  .qr-code{
    position: relative;
    .qr-btn{
      cursor: not-allowed;
      position: relative;
      pointer-events: none; /* 禁用按钮点击事件 */
    }
  }
  .qr-btn::after{
    display: block;
    content: "";
    position: absolute;
    width: 2.5rem;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    z-index: 2;
    background-color:rgba(255, 255, 255, 0.35);
    background-image: none;
  }


}
</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/common-qrcode.vue